import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  font-size: 12px;\n  font-weight: 300;\n  left: 0;\n  line-height: 1.57;\n  margin-bottom: 0;\n  margin-top: -8px;\n  position: absolute;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { ScreenReaderOnly } from '../../ScreenReaderOnly';
import { FIELD_ERROR } from '../../utils/testing/TestIDs';
import styled from '../../utils/styling/styled-components';
var Error = styled.span(_templateObject(), function (props) {
  return props.theme.colors.red;
});
export var FieldError = function FieldError(_ref) {
  var className = _ref.className,
      errorText = _ref.errorText,
      fieldId = _ref.fieldId;
  return /*#__PURE__*/React.createElement(Error, {
    className: className,
    "data-testid": FIELD_ERROR,
    role: "alert" // will be announced to screen reader on render

  }, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Error in ", fieldId, ": "), errorText);
};